import { render, staticRenderFns } from "./UserFrontendEditor.vue?vue&type=template&id=7d0356f8"
import script from "./UserFrontendEditor.vue?vue&type=script&lang=ts"
export * from "./UserFrontendEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports